<template>

  <div class="custom-tab">
    <div class="custom-tab-header">
      <b-row>
        <b-col>
          <b-form-group class="mode-group">
            <b-form-radio-group button-variant="outline-custom" buttons v-model="viewIgnore" :options="options" class="active"></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col class="text-right">
          <b-button size="lg" class="updateallbtn" variant="primary" @click="updateAll()">
            <update-all-icon class="icon-default updateall"></update-all-icon>
            Update All</b-button>
        </b-col>
      </b-row>
    </div>
    <div class="custom-tab-body hasfooter">
      <b-tabs @input="tabSelected" v-if="rawUpdates.length>0">
        <b-tab active>
          <template slot="title">
            <span class="title-count">{{updates['plugins'].length}}</span>
            <span class="tab-title-wrapper ">
              <i class='img-icon plugin'></i>
              <span class="tab-title">
                {{ 'Plugin' | pluralize(updates['plugins'].length)}}
              </span>
            </span>
          </template>
          <div v-if="currentTabIndex==0">
            <entity-updater :entities="updates['plugins']" :type="'plugins'" :buttonLoaders="buttonLoaders" :viewIgnore="viewIgnore" @selectAll="select" @update="update" @ignore="ignore" @unIgnore="unIgnore"></entity-updater>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <span class="title-count">{{updates['themes'].length}}</span>
            <span class="tab-title-wrapper ">
              <i class='img-icon themes'></i>
              <span class="tab-title">
                {{ 'Theme' | pluralize(updates['themes'].length)}}
              </span>
            </span>
          </template>
          <div v-if="currentTabIndex==1">
            <entity-updater :entities="updates['themes']" :type="'themes'" :buttonLoaders="buttonLoaders" :viewIgnore="viewIgnore" @selectAll="select" @update="update" @ignore="ignore" @unIgnore="unIgnore"></entity-updater>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <span class="title-count">{{updates['core'].length}}</span>
            <span class="tab-title-wrapper ">
              <i class='img-icon core'></i>
              <span class="tab-title">
                Core
              </span>
            </span>
          </template>
          <div v-if="currentTabIndex==2">
            <entity-updater :entities="updates['core']" :type="'core'" :buttonLoaders="buttonLoaders" :viewIgnore="viewIgnore" @selectAll="select" @update="update" @ignore="ignore" @unIgnore="unIgnore"></entity-updater>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <span class="title-count">{{updates['translations'].length}}</span>
            <span class="tab-title-wrapper ">
              <i class='img-icon translations'></i>
              <span class="tab-title">
                {{ 'Translation' | pluralize(updates['translations'].length)}}
              </span>
            </span>
          </template>

          <div v-if="currentTabIndex==3">
            <entity-updater :entities="updates['translations']" :type="'translations'" :buttonLoaders="buttonLoaders" :viewIgnore="viewIgnore" @selectAll="select" @update="update" @ignore="ignore" @unIgnore="unIgnore"></entity-updater>
          </div>
        </b-tab>
      </b-tabs>
      <empty-placeholder v-else v-bind="placeholderProps"></empty-placeholder>
    </div>
    <update-modal ref="updatemodal" :updates="rawUpdates" @yes="update"></update-modal>
  </div>

</template>

<script>
import Vue from 'vue';
import UpdateAllIcon from '../../assets/updateAll.svg';
import PluginIcon from '../../assets/plugins.svg';
import ThemeIcon from '../../assets/themes.svg';
import WordpressIcon from '../../assets/wordpress.svg';
import TranslationIcon from '../../assets/translation.svg';
import EntityUpdater from '../Manage/EntityUpdater';
import updateModal from '../modals/UpdateModal';
import EmptyPlaceholder from '../Common/EmptyPlaceholder';

export default {
  name: 'updates',
  components: {
    EntityUpdater,
    updateModal,
    UpdateAllIcon,
    PluginIcon,
    WordpressIcon,
    TranslationIcon,
    ThemeIcon,
    EmptyPlaceholder
  },
  data() {
    return {
      buttonLoaders: {
        update: false,
        ignore: false,
        unIgnore: false
      },
      currentTabIndex: 0,
      selectedUpdates: [],
      showUpdatePopup: false,
      viewIgnore: false,
      options: [
        { text: 'All', value: false },
        { text: 'Ignored', value: true }
      ],
      placeholderProps: {
        text: () => {
          return `Looks like there are no updates available`;
        },
        type: 'positive'
      }
    };
  },
  computed: {
    sites() {
      return this.$store.getters.getSites;
    },
    getSelectedSites() {
      return this.$store.getters.selectedSites;
    },
    getSitesUpdates() {
      return this.$store.getters.getSitesUpdates;
    },
    rawUpdates() {
      let selectedSites = this.getSelectedSites;
      let siteUpdates = this.$store.getters.getUpdates(this.viewIgnore);
      // let viewIgnore = this.viewIgnore;
      // siteUpdates = _.filter(siteUpdates, { hiddenItem: viewIgnore });
      let updates = [];
      _.each(siteUpdates, siteUpdate => {
        let siteId = siteUpdate.siteID;
        let site = _.find(selectedSites, { siteID: siteId });
        if (site) {
          siteUpdate.siteName = site.name;
          updates.push(siteUpdate);
        }
      });
      return updates;
    },
    updates() {
      let updates = this.rawUpdates;
      let processedUpdates = {
        plugins: [],
        themes: [],
        core: [],
        translations: []
      };
      let groupByType = _.groupBy(updates, 'type');
      _.each(groupByType, (group, key) => {
        let groupByURI = _.groupBy(group, 'URI');
        processedUpdates[key] = _.chain(group)
          .groupBy('URI')
          .toPairs()
          .map(function(currentItem) {
            currentItem.push(currentItem[1][0].name);
            return _.zipObject(['URI', 'sites', 'name'], currentItem);
          })
          .value();
      });

      return processedUpdates;
    }
  },
  watch: {
    updates() {
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    }
  },
  methods: {
    getNameByURI(URI) {
      if (URI === 'true') {
        URI = true;
      }
      let update = _.find(this.getSitesUpdates, { URI: URI });
      return update.name;
    },
    showConfirmationPopup() {
      this.showUpdatePopup = true;
    },
    select(payload) {
      let sites = _.filter(this.rawUpdates, { type: payload.type });
      this.$store.commit({
        type: 'SELECT_GROUP_UPDATES',
        sites: sites,
        value: payload.value
      });
    },
    update(event) {
      this.buttonLoaders.update = true;
      let payload = {};
      payload.action = 'updateAll';
      payload.args = {};
      payload.args.params = {};
      let updateArray = {};
      let selectedUpdates = event.value;

      let groupBySites = _.groupBy(selectedUpdates, 'siteID');
      _.each(groupBySites, (sites, siteId) => {
        if (updateArray[siteId] == undefined) {
          updateArray[siteId] = {};
        }
        _.each(sites, site => {
          if (site.type === 'core') {
            updateArray[siteId][site.type] = site.URI;
          } else {
            if (updateArray[siteId][site.type] == undefined) {
              updateArray[siteId][site.type] = [];
            }
            updateArray[siteId][site.type].push(site.URI);
          }
        });
      });

      payload.args.params = updateArray;
      payload.requiredData = {
        getSitesUpdatesV3: 1
      };
      return this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          this.buttonLoaders.update = false;
          this.$refs.updatemodal.$refs.updatemodal.hide();
          this.$store.commit('REMOVE_SITES_UPDATES', selectedUpdates);
          
        })
        .catch(err => {
          
        });
    },
    ignore(selectedParams) {
      this.buttonLoaders.ignore = true;
      let payload = {};
      payload.requiredData = {};
      payload.requiredData['addHideV3'] = {};
      let selectedUpdates = selectedParams.value;
      let updateArray = {};
      _.each(selectedUpdates, update => {
        if (updateArray[update.siteID] == undefined) {
          updateArray[update.siteID] = [];
        }
        updateArray[update.siteID].push({
          name: update.name,
          path: update.URI,
          type: update.type
        });
      });
      payload.requiredData['addHideV3'] = updateArray;
      payload.requiredData['getSitesUpdatesV3'] = 1;

      return this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.$store.commit('REMOVE_SITES_UPDATES', selectedUpdates);
          this.$store.commit(
            'UPDATE_SITES_UPDATES',
            response.data.getSitesUpdatesV3
          );
          this.buttonLoaders.ignore = false;
          
        })
        .catch(err => {
          
        });
    },
    unIgnore(event) {
      this.buttonLoaders.unIgnore = true;
      let payload = {};
      payload.requiredData = {};
      payload.requiredData['removeHideV3'] = {};
      let selectedUpdates = event.value;
      let updateArray = {};
      _.each(selectedUpdates, update => {
        if (updateArray[update.siteID] == undefined) {
          updateArray[update.siteID] = [];
        }
        updateArray[update.siteID].push({
          name: update.name,
          path: update.URI,
          type: update.type
        });
      });
      payload.requiredData['removeHideV3'] = updateArray;
      payload.requiredData['getSitesUpdatesV3'] = 1;
      return this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.buttonLoaders.unIgnore = false;
          
          this.$store.commit('REMOVE_SITES_UPDATES', selectedUpdates);
          this.$store.commit(
            'UPDATE_SITES_UPDATES',
            response.data.getSitesUpdatesV3
          );
        })
        .catch(err => {
          
        });
    },
    updateAll() {
      setTimeout(() => {
        this.$refs.updatemodal.$refs.updatemodal.show();
      }, 100);
    },
    tabSelected(index) {
      this.currentTabIndex = index;
    }
  }
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/pages/Updates.vue